import React from 'react';
import { motion } from 'framer-motion';
export function FailedSolutionsSection() {
  return <section className="w-full bg-warm-white py-16 px-6 md:py-24" data-id="element-13">
      <div className="max-w-reading mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4 font-serif" data-id="element-16">
            Here's the problem with most nocturia advice
          </h2>
          <p className="text-xl text-charcoal/80 mb-12 font-serif italic" data-id="element-17">
            It treats you like the issue is simple.
          </p>

          <div className="space-y-8 mb-12" data-id="element-18">
            {[{
            title: 'You cut water.',
            desc: "Now you're thirsty, uncomfortable, and you still wake up."
          }, {
            title: 'You try random supplements.',
            desc: "Maybe they do nothing. Maybe they make your stomach weird. Maybe you're out money and hope."
          }, {
            title: 'You assume it\'s "just aging."',
            desc: "So you accept nights you shouldn't have to accept."
          }].map((item, index) => <div key={index} className="bg-warm-gray/30 p-8 rounded-xl border border-border-gray/50" data-id="element-19">
                <h3 className="text-xl font-bold text-charcoal mb-3 font-serif" data-id="element-20">
                  {item.title}
                </h3>
                <p className="text-lg text-charcoal/90 leading-relaxed" data-id="element-21">
                  {item.desc}
                </p>
              </div>)}
          </div>

          <p className="text-xl md:text-2xl font-serif text-charcoal leading-relaxed border-l-4 border-amber pl-6 py-2" data-id="element-22">
            But nocturia is often not one single cause.
            <br data-id="element-23" />
            It's usually a pattern driven by a small set of triggers.
            <br data-id="element-24" />
            If you don't identify the trigger, you're stuck in roulette.
          </p>
        </motion.div>
      </div>
    </section>;
}